export const greyDark = "#9D9FB1";
export const textColor = "#3D3D3D";
export const emphasisedTextBlue = "#036DFF";

export const SALEOR_GRAPHQL_URL = "https://demo.saleor.io/graphql/";
export const SALEOR_STOREFRONT_URL = "https://demo.saleor.io/";
